export default {
  API_BASE_URL: 'https://api.sweetlemontraining.com/api',
  STORAGE_BASE_URL: '',
  ADMIN_URL: 'https://admin.sweetlemontraining.com/',
  PRIVACY_POLICY: 'https://admin.sweetlemontraining.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://admin.sweetlemontraining.com/terms-and-conditions',
};
